module.exports = __webpack_public_path__ + "media/images/avatars/user_avatar_portrait-ORIGINAL-157f088b56f86d22066e6df568cbb134.png";